import { Height } from "@mui/icons-material";


import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';


export default  function ApologizeModal(){
    return  (<div><div style={{display:'flex',justifyContent:'center'}}>
        <img  src="/images/login/sorry.jpg" alt="sorry for inconvinience" style={{height:"150px",display:'flex',justifyContent:'center'}}/>
        
        </div>
        <div >
        <h2>Sorry For Inconvinience Network Issue , Just Call Book your ride <span style={{color:'blue'}}> +91 9965821750  </span> </h2>
        </div>
             </div>);
}